import { render } from "./MarketplacesUeberUns.vue?vue&type=template&id=c157c5a6"
import script from "./MarketplacesUeberUns.vue?vue&type=script&lang=ts"
export * from "./MarketplacesUeberUns.vue?vue&type=script&lang=ts"

import "./MarketplacesUeberUns.vue?vue&type=style&index=0&id=c157c5a6&lang=scss"
script.render = render

export default script